import { PlanCardInner } from './plan-card-inner'

export default PlanCardInner
